import { render, staticRenderFns } from "./AdminBaseCandidates.vue?vue&type=template&id=fd12e2f6"
import script from "./AdminBaseCandidates.vue?vue&type=script&lang=js"
export * from "./AdminBaseCandidates.vue?vue&type=script&lang=js"
import style0 from "./AdminBaseCandidates.vue?vue&type=style&index=0&id=fd12e2f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports